var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50026 13.7008C1.36177 13.7008 1.22639 13.6597 1.11124 13.5828C0.996094 13.5058 0.906346 13.3965 0.853349 13.2685C0.800352 13.1405 0.786486 12.9997 0.813504 12.8639C0.840522 12.7281 0.907211 12.6033 1.00514 12.5053L13.0051 0.504101C13.1366 0.373558 13.3145 0.300447 13.4997 0.300782C13.685 0.301118 13.8626 0.374871 13.9936 0.505889C14.1246 0.636907 14.1983 0.814509 14.1987 0.999797C14.199 1.18508 14.1259 1.36295 13.9954 1.49444L1.99538 13.4957C1.9304 13.5608 1.85322 13.6124 1.76826 13.6476C1.68329 13.6828 1.59222 13.7009 1.50026 13.7008Z",
    fill: "#535A5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 13.7008C13.4083 13.7009 13.3172 13.6828 13.2323 13.6476C13.1473 13.6124 13.0701 13.5608 13.0051 13.4957L1.00514 1.49444C0.874611 1.36295 0.801508 1.18508 0.801843 0.999797C0.802178 0.814509 0.875924 0.636907 1.00693 0.505889C1.13793 0.374871 1.31552 0.301118 1.50079 0.300782C1.68605 0.300447 1.8639 0.373558 1.99538 0.504101L13.9954 12.5053C14.0933 12.6033 14.16 12.7281 14.187 12.8639C14.214 12.9997 14.2002 13.1405 14.1472 13.2685C14.0942 13.3965 14.0044 13.5058 13.8893 13.5828C13.7741 13.6597 13.6387 13.7008 13.5003 13.7008Z",
    fill: "#535A5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.1b98d3516586480aafcddb96317289e8.svg";
export { ForwardRef as ReactComponent };